import api from "../../api/api";
import API_URL from "../../api/url";
import axios from "axios";

const VendorRequest = {
  // Fetch filtered list of users
  userFilteredList: (values) =>
    api.get(`${API_URL.BASEURL}${API_URL.getUserFilterSet}`, {
      withCredentials: true,
      params: {
        name: values?.name,
        mobile: values?.mobile,
        roleId: 2,
        isActive: values?.isActive,
      },
    }),
  

    
    getVendorWalletList: (values) =>
      api.post(`${API_URL.BASEURL}${API_URL.getVendorAmountList}`, values,
        {
          withCredentials: true,
        }),

    addVendorWalletAmount: (values) =>
          api.post(`${API_URL.BASEURL}${API_URL.addVendorAmount}`, values,
            {
              withCredentials: true,
            })

      // uploadImage: (formData) => {
      //   const token = localStorage.getItem("accesstoken");
    
      //   return api.post(
      //     `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=staff`,
      //     formData,
      //     {
      //       headers: {
      //         token: token ? `${token}` : "",
      //       },
      //     }
      //   );
      // },
    


};




export default VendorRequest;
